import { Utils } from './../../core/utils';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { CsiHttp } from './../../core/csi-http';
import { Injectable, EventEmitter,  } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoginService {

  api = environment.principal;
  onSairTelaMedico;
  sequencia = new Observable(observer => {
    this.onSairTelaMedico = observer;
  });


  constructor(private http: HttpClient, private httpcsi: CsiHttp) {

   }

  setAction(modulo: number, cdAgencia: number, cdUnidPolicial: number) {
    let url = this.api + '/setAction';
    return this.httpcsi.postIgnore(url, {module: modulo, cdAgencia: cdAgencia, cdUnidPolicial: cdUnidPolicial})
    .map(
      resposta => {
        return resposta;
      }
    );
  }

  isUserLogged(usuario) {
    let url = this.api + '/isUserLoged';
    return this.http.post(url, usuario)
    .map(
      resposta => {
        return resposta;
      }
    );
  }

  verificarVersao() {
    let url = this.api + '/api/verificarVersao';
    return this.httpcsi.get(url)
    .map(
      resposta => {
        return resposta;
      }
    );
  }

  trocarSenha(usuario, novasenha, captchaValue) {
    let url = this.api + '/trocarSenha';
    return this.httpcsi.post(url, {usuario: usuario, senha: novasenha, captchaValue: captchaValue })
    .map(
      resposta => {
        return resposta;
      }
    );
  }
  validarTokenMobile(token: string, usuario: string) {
    let url = this.api + '/validarTokenMobile';
    return this.http.post(url, {
      token: token,
      username: usuario
    })
    .map(
      resposta => {
        return resposta;
      }
    );
  }
  saiuTelaMedico() {
    this.onSairTelaMedico.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/login.service.ts